import { v4 as uuidV4 } from "uuid";

import type { EnvironmentsConfig } from "src/baseConnectionNode/types";
import { DataRetentionUnit } from "src/connections/types";
import type {
  OutputMappingBE,
  SingleMappingBE,
} from "src/integrationNode/types";

export const HttpVerbs = [
  "get",
  "post",
  "patch",
  "delete",
  "options",
  "head",
  "put",
] as const;

export type HttpVerb = (typeof HttpVerbs)[number];

export type KeyValuePair = {
  id_key: string;
  id_value: string;
  key: string;
  value: string;
};

export const getEmptyKeyValuePair = (): KeyValuePair => ({
  id_key: uuidV4(),
  id_value: uuidV4(),
  key: "",
  value: "",
});

export type BodyOption = "key_values" | "raw" | "jinja_template";

export type JinjaBodyContentType = "json" | "xml" | "raw";

export type PostprocessingType =
  | "camel_to_snake"
  | "kebab_to_snake"
  | "xml_to_json";

export type BodyValue =
  | {
      selected: "raw";
      raw: string;
    }
  | {
      selected: "key_values";
      key_values: KeyValuePair[];
    }
  | {
      selected: "jinja_template";
      template: string;
      source: SingleMappingBE;
      content_type: JinjaBodyContentType;
    };

export type CustomConnectionConfig = {
  environments_config?: EnvironmentsConfig;
  testing: {
    use_cached_reports: boolean;
    // Deprecated, keeping for backwards compatibility
    use_fallback_live_connection: boolean;
  };
  caching: {
    active: boolean;
    max_age_seconds: string;
    // Used only for displaying in the UI
    // to properly convert seconds to the correct unit
    unit?: DataRetentionUnit;
  };
  timeout?: {
    active: boolean;
    timeout_seconds: string;
  };
  retry_config?: {
    active: boolean;
  };
  postprocessing_config?: {
    active: boolean;
    type?: PostprocessingType;
  };
  error: {
    allow_4xx: boolean;
    allow_5xx: boolean;
  };
  has_raw_requests_enabled_in_node: boolean;
};

export type CustomConnectionForm = {
  verb: HttpVerb;
  path: SingleMappingBE;
  params: KeyValuePair[];
  headers: KeyValuePair[];
  body: { id: string; value: BodyValue };
  response: OutputMappingBE;
  config: CustomConnectionConfig;
};
